<template>
  <ValidationObserver
    ref="form"
    v-slot="{ invalid, validate, pristine }">
    <form
      @keydown.enter.prevent=""
      @submit.prevent="validate().then(addUser)"
      autocomplete="off">
      <div class="row">
        <div class="col-md-12">
          <label>Role</label>
          <ValidationProvider
            name="Role"
            rules="required"
            v-slot="{ errors }">
            <v-select
              v-model="user.role"
              :options="userRoles"
              placeholder="Select role"
              label="label">
              <template
                slot="option"
                slot-scope="option">
                {{ option.label }}
              </template>
            </v-select>
            <label class="error">{{ errors[0] }}</label>
          </ValidationProvider>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              name="First Name"
              rules="required"
              v-slot="{ errors }">
              <base-input
                id="fname"
                name="fname"
                autocomplete="off"
                type="text"
                label="First Name"
                placeholder="First Name"
                v-model.trim="user.first_name"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider
              name="Last Name"
              rules="required"
              v-slot="{ errors }">
              <base-input
                id="lname"
                name="lname"
                autocomplete="off"
                type="text"
                label="Last Name"
                placeholder="Last Name"
                v-model.trim="user.last_name"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              name="Username"
              rules="required"
              v-slot="{ errors }">
              <base-input
                id="username"
                name="username"
                type="text"
                label="Username"
                placeholder="Username"
                v-model.trim="user.username"
                autocomplete="new-username"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider
              name="Password"
              :rules="`required|min:${passwordMinLength}`"
              v-slot="{ errors }">
              <base-input
                id="password"
                name="password"
                type="password"
                label="Password"
                placeholder="Password"
                v-model.trim="user.password"
                autocomplete="new-password"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <ValidationProvider
              name="Email"
              rules="required|email"
              v-slot="{ errors }">
              <base-input
                id="email"
                name="email"
                type="email"
                label="Email address"
                placeholder="Email"
                v-model.trim="user.email"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
        </div>
      </div>
      <base-button
        id="addUser"
        :disabled="invalid || pristine"
        native-type="submit"
        type="primary"
        class="btn-fill">
        Add User
      </base-button>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import vSelect from 'vue-select';

export default {
  name: 'UserAddForm',
  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  props: {
    reset: {
      type: Boolean,
      default: false,
    },
    userRoles: {
      type: Array,
      required: true,
    },
    passwordMinLength: {
      type: Number,
      required: true,
    },
    userAdded: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      user: {},
    };
  },
  methods: {
    addUser() {
      this.$emit('addUser', this.user);
    },
    resetForm() {
      // reset form values
      Object.keys(this.user).forEach((key) => { this.user[key] = null; });
      this.$nextTick(() => {
        // Reset validation
        this.$refs.form.reset();
      });
    },
  },
  watch: {
    reset() {
      this.resetForm();
    },
    userAdded(added) {
      if (added) {
        this.$emit('close');
        this.resetForm();
      }
    },
  },
};
</script>
